export default __webpack_public_path__ + "static/media/deauville17.23335421.jpg";